
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getCurrencies",
      resolverType: "query",
      routePath: "/getCurrencies",
      httpMethod: "POST",
    });
  